import React, { useState } from "react";

export default function CampaignStage({ encounters, onComplete }) {
  const [index, setIndex] = useState(0);
  const [resolved, setResolved] = useState(null);
  const [log, setLog] = useState([]);

  const encounter = encounters[index];
  const done = index >= encounters.length;

  const applyChoice = (choice) => {
    setLog((prev) => [...prev, { label: encounter.label, choice }]);
    setResolved(choice);
  };

  const advance = () => {
    setResolved(null);
    if (index + 1 < encounters.length) {
      setIndex((i) => i + 1);
    } else {
      onComplete({ log });
    }
  };

  if (done) return null;

  return (
    <div>
      <div className="mb-4 flex items-center justify-between font-display text-[9px] text-mist/50">
        <span>THE CAMPAIGN</span>
        <span>
          {index + 1}/{encounters.length}
        </span>
      </div>

      <div className="animate-popIn mb-5 border-2 border-black bg-ink p-5">
        <p className="pixel-heading mb-3 text-sm text-mist">{encounter.label}</p>
        <p className="text-sm leading-relaxed text-mist/80">{encounter.text}</p>
      </div>

      {!resolved ? (
        <div className="space-y-2">
          {encounter.choices.map((choice) => (
            <button
              key={choice.id}
              onClick={() => applyChoice(choice)}
              className="w-full border-2 border-mist/30 px-4 py-3 text-left text-xs text-mist transition-colors hover:border-cyan hover:text-cyan"
            >
              {choice.label}
            </button>
          ))}
        </div>
      ) : (
        <div
          className={`animate-popIn border-2 p-4 text-center ${
            resolved.tag === "good"
              ? "border-lime bg-lime/10 text-lime"
              : resolved.tag === "bad"
              ? "border-danger bg-danger/10 text-danger"
              : "border-gold bg-gold/10 text-gold"
          }`}
        >
          <p className="mb-3 text-xs">{resolved.result}</p>
          <button onClick={advance} className="btn-cyan !text-[9px]">
            CONTINUE ▶
          </button>
        </div>
      )}
    </div>
  );
}
